export const strBeforeLastOccurrence = (str, char) => {
  const charIndex = str.lastIndexOf(char);

  if (charIndex === -1) return str;

  return str.slice(0, charIndex);
};

export const getTopInstrumentSubStrLabel = (currentLabel) => {
  const colonPosition = currentLabel.indexOf(':');

  const labelToPresent =
    colonPosition < 0
      ? currentLabel
      : currentLabel.substring(colonPosition + 2);

  return labelToPresent;
};
